import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import Button from '@atlaskit/button/standard-button';
import Tooltip from '@atlaskit/tooltip';

import { useIntl } from 'src/hooks/intl';
import { toggleSettingsDialog } from 'src/redux/diff-settings';
import { getUpToSmallBreakpointState } from 'src/selectors/global-selectors';

import { useDiffSettingsButtonAnalytics } from '../../hooks/analytics';

import messages from './i18n';

export const DiffSettingsButton = React.memo(() => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const publishDiffAnalytics = useDiffSettingsButtonAnalytics();
  const isUpToSmallBreakpointActive = useSelector(getUpToSmallBreakpointState);

  const handleClick = () => {
    publishDiffAnalytics();
    dispatch(toggleSettingsDialog(true));
  };

  if (!isUpToSmallBreakpointActive) {
    return (
      <CustomThemeButton
        testId="settingsButton"
        aria-label={intl.formatMessage(messages.iconLabel)}
        onClick={handleClick}
      >
        <FormattedMessage {...messages.modalButton} />
      </CustomThemeButton>
    );
  }

  return (
    <Tooltip content={intl.formatMessage(messages.modalHeading)}>
      <Button
        testId="settingsButton"
        aria-label={intl.formatMessage(messages.iconLabel)}
        onClick={handleClick}
      />
    </Tooltip>
  );
});
